import { render, staticRenderFns } from "./_contact.vue?vue&type=template&id=751347e9&"
import script from "./_contact.vue?vue&type=script&lang=js&"
export * from "./_contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports